export default __webpack_public_path__ + "static/media/washupVoucher3.4061d2d6.png";